module.exports = __webpack_public_path__ + "resources/feature-icon-2-7f651c0a0f8025f3f2f2082138cc7649.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-2.png
// module id = 78
// module chunks = 0